'use client';

import { createContext, useContext } from 'react';

/**
 * Id of the first 'products' block on the page (depth-first through the template), provided by
 * the top-level BlockRenderer. On category templates the grid sits below a heading/description,
 * so it's never the page's first block and its images were all `loading="lazy"`: the browser
 * couldn't request even the first row until CSS and layout were done, although that row is what
 * a visitor waits for (and Lighthouse's LCP on category pages). The first grid loads its first
 * row eagerly instead — without `priority`, which stays reserved for a real first-block hero.
 */
export const FirstProductGridContext = createContext<string | null>(null);

export function useIsFirstProductGrid(blockId: string | undefined): boolean {
  const firstId = useContext(FirstProductGridContext);
  return !!blockId && firstId === blockId;
}

export function findFirstProductGridId(blocks: any[] | undefined | null): string | null {
  for (const block of blocks || []) {
    if (!block || block.type === 'globals') continue;
    if (block.type === 'products' && block.id) return block.id;
    const nested = findFirstProductGridId(block.children);
    if (nested) return nested;
  }
  return null;
}
